/** @type {import('tailwindcss').Config} */

const client = process.env.NEXT_PUBLIC_THEME

const clientConfig = {
  tuuleliinid: require('./tailwind.config.tuuleliinid'),
  kihnu: require('./tailwind.config.kihnu'),
  sark: require('./tailwind.config.sark'),
  trial: require('./tailwind.config.trial'),
}

module.exports = {
  content: ['./src/**/*.{js,ts,jsx,tsx}', './node_modules/@nextui-org/theme/dist/**/*.{js,ts,jsx,tsx}'],
  theme: {
    screens: {
      xxs: '400px',
      xs: '460px',
      sm: '640px',
      md: '800px',
      lg: '1024px',
      xl: '1200px',
    },

    ...clientConfig[client],
    colors: {
      ...clientConfig[client]?.colors,
      black: '#000000',
      white: '#ffffff',
    },
    extend: {
      ...clientConfig[client]?.extend,
      fontSize: {
        small: '13px',
        large: '22px',

        // Type scale of the shared ticket card
        'ticket-title': ['1.25rem', { lineHeight: '1.75rem', fontWeight: '700' }],
        'ticket-desc': ['0.875rem', '1.25rem'],
        'ticket-caption': ['0.875rem', '1.25rem'],
        'ticket-amount': ['1.25rem', '1.75rem'],
        'ticket-subtotal': ['1.25rem', '1.75rem'], // = ticket-amount; a theme that overrides one sets both
        'ticket-qty': ['1.125rem', '1.75rem'],

        // Spread last so a theme config wins. NB: this key is merged rather than replaced — the
        // client spread above it would otherwise drop every per-theme size.
        ...clientConfig[client]?.extend?.fontSize,
      },

      borderRadius: {
        // −/+ buttons of the shared ticket card; = rounded-lg
        'ticket-step': '0.5rem',
        ...clientConfig[client]?.extend?.borderRadius,
      },

      boxShadow: {
        sm: '0 2px 5px 0px rgba(204, 204, 204, 1)',
        'soft-lg': '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
        complex:
          '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
        ...clientConfig[client]?.extend?.boxShadow,
      },
      minWidth: {
        107: '107px',
        130: '130px',
        180: '180px',
        314: '314px',
        400: '400px',
      },
      gridTemplateColumns: {
        'auto-fit': 'repeat(auto-fit, minmax(0, 1fr))',
        filter: '19% 19% 26% 18% 18%',
        tabs: '25% 25% 50%',
        cells: '25% 75%',
        label: '24% 24% 48%, 4%',
      },
      gridArea: {
        details: 'details',
        info: 'info',
        ports: 'ports',
        owner: 'owner',
        kebab: 'kebab',
      },
    },
  },
  corePlugins: {
    focusWithin: true,
  },
  plugins: [
    function ({ addUtilities }) {
      const newUtilities = {
        '.grid-areas': {
          display: 'grid',
          'grid-template-areas': `
            "kebab"
            "details"
            "info"
            "ports"
            "owner"
          `,
          '@media (min-width: 1024px)': {
            'grid-template-areas': `
              "details info ports owner kebab"
            `,
            'grid-template-columns': '10% 25% 35% 25% 5%',
          },
        },
        '.grid-area-details': { 'grid-area': 'details' },
        '.grid-area-info': { 'grid-area': 'info' },
        '.grid-area-ports': { 'grid-area': 'ports' },
        '.grid-area-owner': { 'grid-area': 'owner' },
        '.grid-area-kebab': { 'grid-area': 'kebab' },
      }

      addUtilities(newUtilities)
    },
    function ({ addBase, theme }) {
      addBase({
        ':root': {
          '--color-secondary': theme('colors.secondary'),
          '--color-base-muted': theme('colors.base-muted'),
          '--color-neutral-very-light': theme('colors.neutral-very-light'),
          '--color-neutral-normal-light': theme('colors.neutral-normal-light'),
          '--color-neutral-lightest': theme('colors.neutral-lightest'),
          '--color-base-medium-light': theme('colors.base-medium-light'),
          '--color-primary-base': theme('colors.primary-base'),
          '--color-surface-sunken': theme('colors.surface-sunken', 'transparent'),
          // Sark calendar (DayPicker/sark/styles.module.css)
          '--color-interactive': theme('colors.interactive'),
          '--color-neutral-darker': theme('colors.neutral-darker'),
          '--color-neutral-normal-lighter': theme('colors.neutral-normal-lighter'),
        },
      })
    },
  ],
}
